// Funzione per formattare il titolo tipo "algoritmo-best-execution-mercati-azionari" => "Algoritmo Best Execution Mercati Azionari"
export const formatTitle = (rawTitle?: string): string => {
    if (!rawTitle) return '';
    return rawTitle
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  export const formatDriverRoute = (name?: string) => {
    if (!name) return ''; 
    return name
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]/g, '');
  };

export const formatSnakeToTitle = (raw?: string): string => {
  if (!raw) return '';
  return raw
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// Rimuove caratteri di formattazione Markdown (** * _ ~ ` # >) dal testo degli Highlights
export const formatHighlights = (raw?: string | null): string => {
  if (!raw) return '';
  return raw
    .replace(/\*+/g, '')
    .replace(/_+/g, '')
    .replace(/~+/g, '')
    .replace(/`+/g, '')
    .replace(/^\s*#+\s*/gm, '')
    .replace(/^\s*>\s*/gm, '');
};
